import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element';
import { InspectorControls } from '@wordpress/block-editor';
import {
  BaseControl,
  Button,
  __experimentalToggleGroupControl as ToggleGroupControl,
  __experimentalToggleGroupControlOption as ToggleGroupControlOption,
} from '@wordpress/components';

import PanelBody from '../../components/PanelBody';
import ColorPicker from '../../components/ColorPicker';
import Slider from '../../components/Slider';
import IconsModal from '../../components/IconsModal';
import { getIconClasses } from '../../utils/helpers';

export default function Inspector({ attributes, setAttributes }) {
  const {
    layout,
    contentAlign,
    iconName,
    iconType,
    iconSize,
    iconColor,
    iconBackgroundColor,
    iconShape,
    hoverEffect,
  } = attributes;

  const [isIconsModalOpen, setIsIconsModalOpen] = useState(false);

  return (
    <>
      <InspectorControls>
        <PanelBody title={__('Layout', 'brandy-blocks')} initialOpen>
          <ToggleGroupControl
            label={__('Layout', 'brandy-blocks')}
            value={layout}
            onChange={(value) => setAttributes({ layout: value })}
            isBlock
            __nextHasNoMarginBottom
          >
            <ToggleGroupControlOption
              value="stacked"
              label={__('Stacked', 'brandy-blocks')}
            />
            <ToggleGroupControlOption
              value="inline"
              label={__('Inline', 'brandy-blocks')}
            />
          </ToggleGroupControl>

          <ToggleGroupControl
            label={__('Content alignment', 'brandy-blocks')}
            value={contentAlign}
            onChange={(value) => setAttributes({ contentAlign: value })}
            isBlock
            __nextHasNoMarginBottom
          >
            <ToggleGroupControlOption value="left" label={__('Left', 'brandy-blocks')} />
            <ToggleGroupControlOption
              value="center"
              label={__('Center', 'brandy-blocks')}
            />
            <ToggleGroupControlOption value="right" label={__('Right', 'brandy-blocks')} />
          </ToggleGroupControl>

          <ToggleGroupControl
            label={__('Hover effect', 'brandy-blocks')}
            value={hoverEffect}
            onChange={(value) => setAttributes({ hoverEffect: value })}
            isBlock
            __nextHasNoMarginBottom
          >
            <ToggleGroupControlOption value="none" label={__('None', 'brandy-blocks')} />
            <ToggleGroupControlOption value="lift" label={__('Lift', 'brandy-blocks')} />
          </ToggleGroupControl>
        </PanelBody>

        <PanelBody title={__('Icon', 'brandy-blocks')} initialOpen>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '16px',
            }}
          >
            {iconName && (
              <i
                className={getIconClasses(iconName, iconType)}
                style={{ fontSize: '24px' }}
              />
            )}
            <Button variant="secondary" onClick={() => setIsIconsModalOpen(true)}>
              {iconName
                ? __('Change icon', 'brandy-blocks')
                : __('Choose icon', 'brandy-blocks')}
            </Button>
            {iconName && (
              <Button
                variant="tertiary"
                isDestructive
                onClick={() => setAttributes({ iconName: '' })}
              >
                {__('Remove', 'brandy-blocks')}
              </Button>
            )}
          </div>

          <ToggleGroupControl
            label={__('Shape', 'brandy-blocks')}
            value={iconShape}
            onChange={(value) => setAttributes({ iconShape: value })}
            isBlock
            __nextHasNoMarginBottom
          >
            <ToggleGroupControlOption value="none" label={__('None', 'brandy-blocks')} />
            <ToggleGroupControlOption
              value="circle"
              label={__('Circle', 'brandy-blocks')}
            />
            <ToggleGroupControlOption
              value="square"
              label={__('Square', 'brandy-blocks')}
            />
          </ToggleGroupControl>

          <Slider
            label={__('Size (px)', 'brandy-blocks')}
            value={iconSize}
            onChange={(value) => setAttributes({ iconSize: value })}
            min={16}
            max={120}
          />

          <BaseControl.VisualLabel>
            {__('Icon color', 'brandy-blocks')}
          </BaseControl.VisualLabel>
          <ColorPicker
            color={iconColor}
            onChange={(value) => setAttributes({ iconColor: value })}
          />

          {iconShape !== 'none' && (
            <>
              <BaseControl.VisualLabel>
                {__('Icon background', 'brandy-blocks')}
              </BaseControl.VisualLabel>
              <ColorPicker
                color={iconBackgroundColor}
                onChange={(value) => setAttributes({ iconBackgroundColor: value })}
              />
            </>
          )}
        </PanelBody>
      </InspectorControls>

      <IconsModal
        isIconsModalOpen={isIconsModalOpen}
        setIsIconsModalOpen={setIsIconsModalOpen}
        icon={{ name: iconName, type: iconType }}
        setAttributes={(newAttrs) =>
          setAttributes({ iconName: newAttrs.name, iconType: newAttrs.type })
        }
      />
    </>
  );
}
